module.exports = __webpack_public_path__ + "74f0fed398df96745ff8f360771bfc99.png";